import { defineStore } from 'pinia';
import { markRaw } from 'vue';
import { proxyUrl } from '/config';
import ApiClient from '@/ApiClient';

export const useAppStore = defineStore('app', {
  state: () => ({
    apiClient: markRaw(new ApiClient(proxyUrl)),
    appMode: 'schedules',
    dataLoaded: false,
    theme: 'light',
    buildMode: 'production',
    showWelcomeDialog: true,
    loadDashboard: true,
    defaultRoute: null,
  }),
  getters: {
    getAppMode: (state) => state.appMode,
    getDataLoaded: (state) => state.dataLoaded,
    getLoadDashboard: (state) => state.loadDashboard,
    getShowWelcomeDialog: (state) => state.showWelcomeDialog,
    getApiClient: (state) => state.apiClient,
    getBuildMode: (state) => state.buildMode,
    chartFontColor: (state) => (state.theme === 'light' ? '#000000' : '#FFFFFF'),
  },
  actions: {
    setAppMode(mode) {
      this.appMode = mode;
    },
    setTheme(newTheme) {
      this.theme = newTheme;
    },
    setDataLoaded(value) {
      this.dataLoaded = value;
    },
    setLoadDashboard(value) {
      this.loadDashboard = value;
    },
    setShowWelcomeDialog(value) {
      this.showWelcomeDialog = value;
    },
    setBuildMode(value) {
      this.buildMode = value;
    },
    setDefaultRoute(route) {
      this.defaultRoute = route;
    },
    setApiUrl(apiUrl) {
      this.apiClient.apiUrl = apiUrl;
    },
    updateApiUrl(apiUrl) {
      this.setApiUrl(apiUrl);
    },
    updateTheme(theme) {
      this.setTheme(theme);
    },
    updateLoadDashboard(loadDashboard) {
      this.setLoadDashboard(loadDashboard);
    },
    updateShowWelcomeDialog(showWelcomeDialog) {
      this.setShowWelcomeDialog(showWelcomeDialog);
    },
    updateBuildMode(buildMode) {
      this.setBuildMode(buildMode);
    },
  },
});
